import React from "react";
import {messageIsAudio} from "../../models/message";
import MessageAudio from "./message_audio/message_audio.js";

export const MESSAGE_TYPES = {
    DATE: "date",
    AGENT: "agent",
    SENT: "sent",
    RECEIVED: "received", 
}

function formatTimeString(date) {
    const dualize = (x) => (x < 10 ? "0" + x : x)

    const getTime = () => dualize(date.getHours()) + ":" + dualize(date.getMinutes())

    return getTime()
}

function formatDateString(date) {
    const dualize = (x) => (x < 10 ? "0" + x : x)

    const getDate = () => dualize(date.getDate()) + "/" + dualize(date.getMonth() + 1) + "/" + dualize(date.getFullYear())

    const dateDiff = Math.round((Date.now() - date) / (1000 * 60 * 60 * 24))

    if (dateDiff === 0) {
        return "Hoy"
    } else if (dateDiff === 1) {
        return "Ayer"
    } else {
        return getDate()
    }
}

function messageStatusCheck(msg) {
    if (msg.status === 0) {
        return <i className="fas fa-check"></i>
    } else if (msg.status === 1) {
        return <i className="fas fa-check-double"></i>
    } else if (msg.status === 2) {
        return <i style={{ color: "rgb(90,150,212)" }} className="fas fa-check-double"></i>
    }
}

/**
 *
 * @param type
 * @param index
 * @param message
 * @param onImageClick
 * @returns {JSX.Element}
 */
export function Message({type, index, message, onImageClick}) {
    let response = null;
    switch (type) {
        case MESSAGE_TYPES.DATE:
            response = MessageDate({index: index, message: message});
            break;
        case MESSAGE_TYPES.AGENT:
            response = MessageAgent({index: index, message: message});
            break;
        case MESSAGE_TYPES.RECEIVED:
            response = MessageReceived({index: index, message: message, onImageClick: onImageClick});
            break;
        case MESSAGE_TYPES.SENT:
            response = MessageSent({index: index, message: message, onImageClick: onImageClick});
            break;
        default:
            break;
    }
    return response;
}

/**
 *
 * @param {{message:{time:string}}} props
 * @returns {JSX.Element}
 */
export function MessageDate({message, index}) {
    return <div key={message.time + "-" + index} className="mx-auto my-2 bg-primary text-white small py-1 px-2 rounded">
        {formatDateString(new Date(message.time))}
    </div>
}

export function MessageAgent({message, index}) {
    return <div key={message.time + "-" + index + "-" + message.brAgent}
                className="mx-auto my-2 bg-success text-white small py-1 px-2 rounded">
        Agente: {message.brAgent}
    </div>
}

export function MessageSystem({message, index}) {
    return <div key={"system" + message.time + "-" + index + "-" + message.brAgent} className="mx-auto my-2 text-white small py-1 px-2 rounded text-center" style={{backgroundColor: '#f5a110', maxWidth: '60vw'}}>
        <div dangerouslySetInnerHTML={{ __html: parseBBCodeToHtml(message.body) }}></div>
    </div>
}

export function MessageSent({message, index, onImageClick}) {
    const body = parseBBCodeToHtml(message.body);
    
    const handleClick = (e) => {
        // console.log('MessageSent click:', e.target, e.target.tagName);
        if (e.target.tagName === 'IMG') {
            // console.log('Image clicked, src:', e.target.src);
            e.preventDefault();
            e.stopPropagation();
            if (onImageClick) {
                onImageClick(e.target.src);
            }
        }
    };
    
    return <div key={message.sender + "_" + index + "-" + message.time}
        className="align-self-end self p-1 my-1 mx-3 rounded bg-white shadow-sm message-item"
        onClick={handleClick}>
        <div className="d-flex flex-column" style={{ maxWidth: messageIsAudio(message) ? "30vw" : "auto" }}>
            { messageIsAudio(message) &&
                <MessageAudio message={message} index={index} />
            }
            <div className={"body m-1 mr-2" + (messageIsAudio(message) ? " text-muted ml-3" : "")}
                 dangerouslySetInnerHTML={{ __html: messageIsAudio(message) ? '&ldquo;' + body + '&rdquo;' : body }}></div>
            <div className="time ml-auto small text-right flex-shrink-0 align-self-end text-muted"
                style={{ width: "75px" }}>
                {formatTimeString(new Date(message.time))}
                <span> {messageStatusCheck(message)}</span>
            </div>
        </div>
    </div>
}

export function MessageReceived({message, index, onImageClick}) {
    let body = parseBBCodeToHtml(message.body);
    
    const handleClick = (e) => {
        if(e.target.dataset.openview === "false"){
            return;
        } else {        
            // console.log('MessageReceived click:', e.target, e.target.tagName);
            if (e.target.tagName === 'IMG') {
                // console.log('Image clicked, src:', e.target.src);
                e.preventDefault();
                e.stopPropagation();
                onImageClick && onImageClick(e.target.src);
            }
        }
    };
    
    return <div key={message.sender + "-a-" + index + "-" + message.time}
        className="align-self-start p-1 my-1 mx-3 rounded bg-white shadow-sm message-item"
        onClick={handleClick}>
        <div className="d-flex flex-column" style={{ maxWidth: messageIsAudio(message) ? "30vw" : "auto" }}>
            { messageIsAudio(message) &&
                <MessageAudio message={message} index={index} />
            }
            <div className={"body m-1 mr-2" + (messageIsAudio(message) ? " text-muted ml-3" : "")}
                 dangerouslySetInnerHTML={{ __html: messageIsAudio(message) ? (body != '' ? '&ldquo;' + body + '&rdquo;' : "") : body }}></div>

            <div className="time ml-auto small text-right flex-shrink-0 align-self-end text-muted"
                style={{ width: "75px" }}>
                {formatTimeString(new Date(message.time))}
            </div>
        </div>
    </div>
}

function parseBBCodeToHtml(value) {
    value = value
        .trim()
        .replace(/~(.*)~/g, "<del>$1</del>")
        .replace(/\*(.*)\*/g, "<strong>$1</strong>")
        .replace(/```(.*)```/g, "<code>$1</code>")
        .replace(/\n/g, "<br/>");

    if (!value.startsWith("<")) {
        value = value.replace(/_(.*)_/g, "<em>$1</em>");
    }
    // Solo agregar atributos de cursor a imágenes existentes, sin modificar la estructura
    value = value.replace(/<img([^>]*?)>/gi, function(match, attributes) {
        if (!attributes.includes('data-image-viewer')) {
            // Solo agregar nuestros atributos si no los tiene ya
            return match.replace('>', ' data-image-viewer="true" style="cursor: pointer; max-width: 100%; height: auto;">');
        }
        return match;
    });
    return value;
}